import React from 'react';

export default function CategoryBadge({
  category,
  audience,
  size = 'sm',
  className = '',
}) {
  const sizeClasses = {
    xs: 'text-[9px] px-1.5 py-0.5 tracking-wider',
    sm: 'text-[11px] px-2 py-0.5 tracking-wider',
    md: 'text-xs px-2.5 py-1 tracking-wider',
  }[size] || 'text-[11px] px-2 py-0.5 tracking-wider';

  const audienceLabel = audience === 'privat'
    ? 'For Private'
    : audience === 'erhverv'
    ? 'For Erhverv'
    : audience === 'begge'
    ? 'Privat & Erhverv'
    : null;

  return (
    <div className={`inline-flex flex-wrap items-center gap-1.5 font-medium uppercase ${className}`}>
      {audienceLabel && (
        <span
          className={`inline-block rounded-xs font-semibold border ${sizeClasses} ${
            audience === 'erhverv'
              ? 'border-[#fd7302]/30 bg-[#fff7ed] text-[#fd7302]'
              : audience === 'privat'
              ? 'border-[#010b27]/25 bg-[#010b27]/5 text-[#010b27]'
              : 'border-slate-300 bg-slate-50 text-slate-700'
          }`}
        >
          {audienceLabel}
        </span>
      )}
      {category && (
        <span
          className={`inline-block rounded-xs border border-slate-200 bg-slate-50 font-semibold text-slate-600 ${sizeClasses}`}
        >
          {category}
        </span>
      )}
    </div>
  );
}
